import {Component, computed, input} from '@angular/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-step-key-number',
  imports: [],
  templateUrl: './iackathon-step-key-number.component.html',
  styleUrl: './iackathon-step-key-number.component.scss',
})
export class IackathonStepKeyNumberComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save().attributes.content.state);
    private keyNumberData = computed(() => this.state().sdg_theme_step?.top_group_answers);
    protected firstNumber = computed(() => this.state().sdg_theme_step?.top_group_answers?.first_number);
    protected secondNumber = computed(() => this.state().sdg_theme_step?.top_group_answers?.second_number);
    protected thirdNumber = computed(() => this.state().sdg_theme_step?.top_group_answers?.third_number);
}
